import React from 'react';
import { useTheme } from '@mui/material/styles';

import { ReactComponent as MicOffIcon } from '../assets/icons/icon_mic_off.svg';
import { ReactComponent as MicOnIcon } from '../assets/icons/icon_mic_on.svg';
import { ReactComponent as VideoOffIcon } from '../assets/icons/icon_video_off.svg';
import { ReactComponent as VideoOnIcon } from '../assets/icons/icon_video_on.svg';

const icons = {
  micOff: MicOffIcon,
  micOn: MicOnIcon,
  videoOff: VideoOffIcon,
  videoOn: VideoOnIcon,
};

export function Icon({ name, color, ...props }) {
  const theme = useTheme();

  const themeColorMap = {
    danger: theme.palette.error.main,
    white: theme.palette.white,
    gray: theme.palette.grey,
    primary: theme.palette.primary.main,
    success: theme.palette.success.main,
    black: theme.palette.black,
  };

  const fill = themeColorMap[color] ?? color ?? 'currentColor';

  const style = {
    ...props.style,
    color: fill,
  };

  return React.createElement(icons[name], {
    style,
    width: 24,
    height: 24,
    ...props,
  });
}

export { MicOffIcon, MicOnIcon, VideoOffIcon, VideoOnIcon };
